import React, { useCallback, useEffect } from 'react';
// import useLocalStorage from 'hooks/useLocalStorage';
import history from 'historyContainer';
import PropTypes from 'prop-types';
import { map, toUpper, get } from 'lodash';
import { Row, Col } from '@zendeskgarden/react-grid';
import { Tooltip } from '@zendeskgarden/react-tooltips';
import Icon from 'components/Icon/Icon';
import { variables } from 'theme/variables';
import { Table, Head, HeaderCell } from '@zendeskgarden/react-tables';
import { SM } from '@zendeskgarden/react-typography';
import { useBranch } from 'baobab-react/hooks';
import { getRfqMeta } from 'state/requestForQuote/actions';
// import { getSavedListingInterests } from 'state/wishlistInterests/actions';
import {
  RelatedListingCard,
  RelatedListingsWrapper,
  HeaderTitles,
} from './RelatedListingsMiniTable.styles';

const {
  custom_blue: customBlue,
  custom_dark_grey: customDarkGrey,
  custom_green: customGreen,
} = variables;

function RelatedListingsMiniTable({ data }) {
  const currentData = data || {};
  // TODO: P2-1570 Commented out wishlist functionality. Leaving code and styling in case we want to add it back in later. 11-2023
  // const [savedItems, setSavedItems] = useLocalStorage('wishListSavedItems', []);

  const { rfqMeta } = useBranch({
    rfqMeta: ['requestForQuote', 'meta'],
  });

  const inspectionScopes = get(rfqMeta, 'result.inspection_status_types');

  // const inLocalStore = useCallback(
  //   (id) => includes(savedItems, id),
  //   [savedItems]
  // );

  // useEffect(() => {
  //   getSavedListingInterests(savedItems);
  // }, [savedItems]);

  useEffect(() => {
    getRfqMeta();
  }, []);

  // const memoAddOrRemoveFromLocalStore = useCallback(
  //   (e, id) => {
  //     e.stopPropagation();

  //     if (includes(savedItems, id)) {
  //       setSavedItems((prevArr) =>
  //         filter(prevArr, (storageId) => storageId !== id)
  //       );
  //     } else {
  //       setSavedItems((prevArr) => [id, ...prevArr]);
  //     }
  //   },
  //   [setSavedItems, savedItems]
  // );

  const memoEvaluateScope = useCallback(
    (id, field) => get(get(inspectionScopes, id), field),
    [inspectionScopes]
  );

  function createListingLink(listing) {
    const { id, uuid, slug } = listing;
  
    if (slug && uuid) {
      return `/l/${slug}/${uuid}/`;
    } else if (slug && id) {
      return `/l/${slug}/${id}/`;
    } else {
      return '';
    }
  }

  return (
    <div
      style={{
        overflowX: 'auto',
        boxShadow: `1px 1px 7px -2px ${customDarkGrey}`,
      }}
    >
      <Table
        style={{ minWidth: '1040px', position: 'sticky', top: 0, zIndex: 8 }}
      >
        <Head>
          <HeaderTitles>
            <HeaderCell
              width="37%"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Item Description & Specifications
            </HeaderCell>
            <HeaderCell
              width="10%"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Quantity
            </HeaderCell>
            <HeaderCell
              width="20%"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Manufacturer
            </HeaderCell>
            <HeaderCell
              width="23%"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Current Location
            </HeaderCell>
            <HeaderCell
              width="10%"
              style={{
                padding: '5px 12px 5px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Inspection Status
            </HeaderCell>
          </HeaderTitles>
        </Head>
      </Table>
      <RelatedListingsWrapper>
        {map(currentData, (listing) => (
          <Row className="listingRow" key={`listing-${listing?.id}`} lg={12}>
            <RelatedListingCard>
              <Col lg={1}>
                <Tooltip
                  className="tooltip_styling"
                  zIndex={9}
                  placement="auto"
                  refKey="ref"
                  trigger={
                    <>
                      {listing?.image_url ? (
                        <img
                          className="listing_image"
                          src={listing?.image_url}
                          alt={`listing_image_${listing?.id}`}
                        />
                      ) : (
                        <div className="defaultImage_listing" />
                      )}
                      {/* <Icon
                        className="heartIcon"
                        fontAwesome
                        icon="heart"
                        iconPrefix={`${
                          inLocalStore(listing?.id) ? 'fas' : 'far'
                        }`}
                        fontSize="25px"
                        style={{ color: customBlue, width: '15px' }}
                        onClick={(e) =>
                          memoAddOrRemoveFromLocalStore(e, listing?.id)
                        }
                      /> */}
                    </>
                  }
                >
                  <div>
                    <div
                      className="tooltipListingName"
                      role="link"
                      onClick={() =>
                        history.push(createListingLink(listing))
                      }
                      onKeyUp={() =>
                        history.push(createListingLink(listing))
                      }
                      tabIndex={0}
                    >
                      {listing?.title || listing?.name || 'N/A'}
                    </div>
                    {listing?.image_url ? (
                      <img
                        className="tooltip_listing_image"
                        src={listing?.image_url}
                        alt={`listing_image_${listing?.id}`}
                      />
                    ) : (
                      <div className="listing_image defaultImage" />
                    )}
                  </div>
                </Tooltip>
              </Col>
              <Col
                lg={3}
                className="listingName"
                onClick={() =>
                  history.push(createListingLink(listing))
                }
              >
                {listing?.title || listing?.name || 'N/A'}
              </Col>
              <Col lg={2} className="listingQuantity">
                {`${listing?.quantity || '--'} ${toUpper(
                  listing?.quantity_uom_name
                )}`}
              </Col>
              <Col lg={2} className="withIcon listingManufacturer">
                <Icon
                  className="listingIcon"
                  fontAwesome
                  icon="industry-alt"
                  iconPrefix="fad"
                  fontSize="30px"
                  style={{ color: customBlue, opacity: '0.2' }}
                />
                {listing?.manufacturer || '--'}
              </Col>
              <Col lg={3} className="withIcon listingLocation">
                <Icon
                  className="listingIcon"
                  fontAwesome
                  icon="map-marked-alt"
                  iconPrefix="fad"
                  fontSize="30px"
                  style={{ color: customBlue, opacity: '0.2' }}
                />
                {listing?.location_description || 'N/A'}
              </Col>
              <Col
                lg={1}
                className="withIcon"
                style={{ justifyContent: 'space-evenly' }}
              >
                <Tooltip
                  className="tooltip_styling inspection"
                  zIndex={9}
                  placement="auto"
                  refKey="ref"
                  trigger={
                    <img
                      className="actionIcons"
                      alt="inspectionStatusImage"
                      style={{ width: '35px' }}
                      src="/images/CircledCheck.svg"
                    />
                  }
                >
                  <div
                    className="true_tooltip"
                    style={{ zIndex: 12, height: '250px', marginLeft: '-25px' }}
                  >
                    <div className="listingInspectionTooltipHeader">
                      <img
                        alt="Pipefacts Logo"
                        style={{
                          maxWidth: '50%',
                          marginRight: '10px',
                        }}
                        src="/images/pipeFactsV2.svg"
                      />
                      <SM style={{ fontWeight: '600' }}>
                        {memoEvaluateScope(
                          listing?.inspection_status_id,
                          'header'
                        )}
                      </SM>
                    </div>
                    <ul className="listingInspectionList">
                      {map(
                        memoEvaluateScope(
                          listing?.inspection_status_id,
                          'inspections'
                        ),
                        (inspection) => (
                          <li
                            key={inspection}
                            className="listingInspectionItem"
                          >
                            <Icon
                              style={{ paddingRight: '3px' }}
                              fontAwesome
                              color={customGreen}
                              icon="check-circle"
                              fontSize="12px !important"
                            />
                            {inspection}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </Tooltip>
              </Col>
            </RelatedListingCard>
          </Row>
        ))}
      </RelatedListingsWrapper>
    </div>
  );
}

RelatedListingsMiniTable.propTypes = {
  // LINT OVERRIDE #8
  // TECH DEBT
  // Array has undetermined elements
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array,
};

export default RelatedListingsMiniTable;
